import { WodStructure, WodElementType, WodType, WodGroup, WodMovement } from '../types/wod.types';
import { v4 as uuidv4 } from 'uuid';

export interface WodTemplate {
  id: string;
  name: string;
  type: WodType;
  description: string;
  timeCap?: number;
  structure: WodStructure;
  category: 'benchmark' | 'hero' | 'girl' | 'custom';
  difficulty: 'RX' | 'Scaled' | 'Beginner';
}

export const WOD_TEMPLATES: WodTemplate[] = [
  // GIRL WODs - Benchmarks courts et intenses
  {
    id: 'fran',
    name: 'Fran',
    type: WodType.FOR_TIME,
    description: 'WOD benchmark emblématique - 21-15-9 Thrusters et Pull-ups',
    timeCap: 10,
    category: 'girl',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.GROUP,
          repetitions: 3,
          isAmrap: false,
          name: '21-15-9',
          children: [
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Thrusters',
              notes: '43kg / 30kg'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Pull-ups'
            } as WodMovement
          ]
        } as WodGroup
      ]
    }
  },

  {
    id: 'grace',
    name: 'Grace',
    type: WodType.FOR_TIME,
    description: '30 Clean and Jerks le plus vite possible',
    timeCap: 10,
    category: 'girl',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.MOVEMENT,
          description: 'Clean and Jerk',
          reps: 30,
          notes: '60kg / 40kg'
        } as WodMovement
      ]
    }
  },

  {
    id: 'cindy',
    name: 'Cindy',
    type: WodType.AMRAP,
    description: 'AMRAP 20 minutes - 5 Pull-ups, 10 Push-ups, 15 Squats',
    timeCap: 20,
    category: 'girl',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.GROUP,
          repetitions: 1,
          isAmrap: true,
          name: 'AMRAP 20min',
          children: [
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Pull-ups',
              reps: 5
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Push-ups',
              reps: 10
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Air Squats',
              reps: 15
            } as WodMovement
          ]
        } as WodGroup
      ]
    }
  },

  {
    id: 'diane',
    name: 'Diane',
    type: WodType.FOR_TIME,
    description: '21-15-9 Deadlifts et Handstand Push-ups',
    timeCap: 10,
    category: 'girl',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.GROUP,
          repetitions: 3,
          isAmrap: false,
          name: '21-15-9',
          children: [
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Deadlifts',
              notes: '100kg / 70kg'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Handstand Push-ups'
            } as WodMovement
          ]
        } as WodGroup
      ]
    }
  },

  {
    id: 'karen',
    name: 'Karen',
    type: WodType.FOR_TIME,
    description: '150 Wall Balls le plus vite possible',
    timeCap: 15,
    category: 'girl',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.MOVEMENT,
          description: 'Wall Balls',
          reps: 150,
          notes: '9kg / 6kg à 3m'
        } as WodMovement
      ]
    }
  },

  // HERO WODs - En l'honneur de soldats tombés au combat
  {
    id: 'murph',
    name: 'Murph',
    type: WodType.FOR_TIME,
    description: 'Hero WOD en l\'honneur du Lt. Michael Murphy - avec gilet lesté',
    timeCap: 60,
    category: 'hero',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.MOVEMENT,
          description: 'Run',
          reps: 1,
          notes: '1 mile (1.6km)'
        } as WodMovement,
        {
          id: uuidv4(),
          type: WodElementType.GROUP,
          repetitions: 1,
          isAmrap: false,
          name: 'Main WOD',
          children: [
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Pull-ups',
              reps: 100
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Push-ups',
              reps: 200
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Air Squats',
              reps: 300
            } as WodMovement
          ]
        } as WodGroup,
        {
          id: uuidv4(),
          type: WodElementType.MOVEMENT,
          description: 'Run',
          reps: 1,
          notes: '1 mile (1.6km)'
        } as WodMovement
      ]
    }
  },

  {
    id: 'dt',
    name: 'DT',
    type: WodType.FOR_TIME,
    description: 'Hero WOD - 5 rounds de Deadlift, Hang Power Clean, Push Jerk',
    timeCap: 20,
    category: 'hero',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.GROUP,
          repetitions: 5,
          isAmrap: false,
          name: '5 Rounds',
          children: [
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Deadlifts',
              reps: 12,
              notes: '70kg / 47.5kg'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Hang Power Cleans',
              reps: 9,
              notes: '70kg / 47.5kg'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Push Jerks',
              reps: 6,
              notes: '70kg / 47.5kg'
            } as WodMovement
          ]
        } as WodGroup
      ]
    }
  },

  // BENCHMARK WODs - Tests de performance classiques
  {
    id: 'helen',
    name: 'Helen',
    type: WodType.FOR_TIME,
    description: '3 rounds de Run, KB Swings, Pull-ups',
    timeCap: 15,
    category: 'benchmark',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.GROUP,
          repetitions: 3,
          isAmrap: false,
          name: '3 Rounds',
          children: [
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Run',
              reps: 1,
              notes: '400m'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Kettlebell Swings',
              reps: 21,
              notes: '24kg / 16kg'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Pull-ups',
              reps: 12
            } as WodMovement
          ]
        } as WodGroup
      ]
    }
  },

  {
    id: 'annie',
    name: 'Annie',
    type: WodType.FOR_TIME,
    description: '50-40-30-20-10 Double Unders et Sit-ups',
    timeCap: 12,
    category: 'benchmark',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.GROUP,
          repetitions: 5,
          isAmrap: false,
          name: '50-40-30-20-10',
          children: [
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Double Unders'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Sit-ups'
            } as WodMovement
          ]
        } as WodGroup
      ]
    }
  },

  {
    id: 'fight-gone-bad',
    name: 'Fight Gone Bad',
    type: WodType.AMRAP,
    description: '3 rounds de 5 stations de 1 minute chacune',
    timeCap: 17,
    category: 'benchmark',
    difficulty: 'RX',
    structure: {
      elements: [
        {
          id: uuidv4(),
          type: WodElementType.GROUP,
          repetitions: 3,
          isAmrap: false,
          name: '3 Rounds',
          children: [
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Wall Balls',
              notes: '9kg / 6kg - 1 minute'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Sumo Deadlift High Pull',
              notes: '35kg / 25kg - 1 minute'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Box Jumps',
              notes: '60cm / 50cm - 1 minute'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Push Press',
              notes: '35kg / 25kg - 1 minute'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Row for Calories',
              notes: '1 minute'
            } as WodMovement,
            {
              id: uuidv4(),
              type: WodElementType.MOVEMENT,
              description: 'Rest',
              notes: '1 minute'
            } as WodMovement
          ]
        } as WodGroup
      ]
    }
  }
];

// Fonctions utilitaires pour les templates
export const getTemplatesByCategory = (category: WodTemplate['category']) => {
  return WOD_TEMPLATES.filter(t => t.category === category);
};

export const getTemplateById = (id: string) => {
  return WOD_TEMPLATES.find(t => t.id === id);
};

export const searchTemplates = (query: string) => {
  const lowerQuery = query.toLowerCase();
  return WOD_TEMPLATES.filter(t =>
    t.name.toLowerCase().includes(lowerQuery) ||
    t.description.toLowerCase().includes(lowerQuery)
  );
};
